export default "__VITE_ASSET__G4Rfr0al__"